<section class="modal-video" *ngIf="_video.active">
    <button class="btn-close" (click)="_video.dismiss()">
        <i class="fas fa-times"></i>
    </button>
    <div class="modal-video__box">
        <iframe [src]="_video.url" frameborder="0" allow="autoplay" width="640" height="480" allowfullscreen></iframe>
    </div>
    <div class="modal-video-backdrop" (click)="_video.dismiss()"></div>
</section>